module.exports = __webpack_public_path__ + "static/media/for-businesses.d0f424ce.svg";